import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=57a731da&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=57a731da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a731da",
  null
  
)

export default component.exports